import React, { useState, useEffect, useContext, useRef, useLayoutEffect, useCallback, useMemo, Suspense, lazy } from "react";
import "emoji-mart/css/emoji-mart.css";
import { useParams } from "react-router-dom";
import { Picker } from "emoji-mart";
import MicRecorder from "mic-recorder-to-mp3";
import clsx from "clsx";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import IconButton from "@material-ui/core/IconButton";
//import MoreVert from "@material-ui/icons/MoreVert";
import MoodIcon from "@material-ui/icons/Mood";
import CommentIcon from "@material-ui/icons/Comment";
import SendIcon from "@material-ui/icons/Send";
import CancelIcon from "@material-ui/icons/Cancel";
import ClearIcon from "@material-ui/icons/Clear";
import MicIcon from "@material-ui/icons/Mic";
import CheckIcon from '@material-ui/icons/Check';
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

import {
  Backdrop,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fade,
  FormControlLabel,
  Modal,
  //Hidden,
  //Menu,
  //MenuItem,
  Switch,
  TableFooter,
  Typography,
} from "@material-ui/core";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import { i18n } from "../../translate/i18n";
import api, { createApi } from "../../services/api";
import RecordingTimer from "./RecordingTimer";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import usePrecoTabelas from "../../hooks/usePrecoTabelas";
import RenderTableProdutosRoma from "./RenderTableProdutosRoma";
import { toast } from "react-toastify";
import BarraProdutosFiltro from "./BarraProdutosFiltro";
import { montarOpcoesGrupos, filtrarProdutosPorGrupos } from "./gruposProdutos";
import { TagProdutoPromocional, estiloLinhaProdutoPromocional } from "./ProdutoPromocional";
import toastError from "../../errors/toastError";
import { mensagemErroMicrofone, microfoneDisponivel } from "../../helpers/erroMicrofone";
import InternalNoteModal from "../InternalNoteModal";
import ItensLeadModal from "../ItensLeadModal";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import { BotaoCancelar, BotaoConfirmar } from "../BotoesModal";
import {
  avaliarAnexo,
  formatarTamanho,
  LIMITE_DOCUMENTO,
  LIMITE_VIDEO,
} from "../../helpers/limitesMidia";
import { registrarConsumidorEsc } from "../../helpers/escConversa";

import { InputLabel, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import InventoryIcon from '@mui/icons-material/Inventory';
import { SearchOutlined } from "@material-ui/icons";
import PriceTableSelector from "../PriceTableSelector";

const MediasModal = lazy(() => import("../MediasModal"));

const Mp3Recorder = new MicRecorder({ bitRate: 128 });

// O AudioContext é criado pela lib ANTES de pedir o microfone, e o stop() dela
// só fecha o contexto quando a gravação chegou a começar. Falha ao abrir o
// microfone deixava um contexto aberto por tentativa — e o Chrome recusa criar
// além de meia dúzia deles, virando erro em todo clique seguinte até dar F5.
const liberarContextoAudio = () => {
  try {
    const contexto = Mp3Recorder.context;
    if (contexto && contexto.state !== "closed") contexto.close();
  } catch (e) { /* já fechado */ }
};

const MAX_PRODUTOS_BUSCA = 25;

// Preço de venda crescente. O ERP manda preço ausente como 0 (RestUtil.convertForBigDecimal),
// e a lista é cortada em MAX_PRODUTOS_BUSCA — sem separar os dois, produto sem preço tomaria
// as primeiras linhas. Empate desempata por nome pra ordem não dançar entre renders.
const precoDeVenda = (item) => {
  const preco = Number(item?.precoVenda);
  return Number.isFinite(preco) && preco > 0 ? preco : null;
};

const compararPorPrecoVenda = (a, b) => {
  const precoA = precoDeVenda(a);
  const precoB = precoDeVenda(b);

  if ((precoA === null) !== (precoB === null)) return precoA === null ? 1 : -1;
  if (precoA !== null && precoA !== precoB) return precoA - precoB;

  return (a?.nome ?? "").toString().localeCompare((b?.nome ?? "").toString(), "pt-BR");
};

const useStyles = makeStyles((theme) => ({
  mainWrapper: {
    background: "var(--surface-2)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderTop: "1px solid var(--border)",
  },

  newMessageBox: {
    background: theme.palette.background.default,
    width: "100%",
    display: "flex",
    padding: "7px",
    alignItems: "center",
  },

  messageInputWrapper: {
    padding: 6,
    marginRight: 7,
    background: theme.palette.background.paper,
    display: "flex",
    flexDirection: "column",
    borderRadius: 20,
    flex: 1,
    position: "relative",
    minHeight: '4rem'

  },

  messageInput: {
    paddingLeft: 10,
    flex: 1,
    border: "none",
  },

  sendMessageIcons: {
    color: "grey",
  },

  uploadInput: {
    display: "none",
  },

  viewMediaInputWrapper: {
    display: "flex",
    padding: "10px 13px",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "var(--surface-2)",
    borderTop: "1px solid var(--border)",
  },

  viewMediaInputWrapperCurso: {
    display: "flex",
    padding: "10px 13px",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "var(--surface-2)",
    borderTop: "1px solid var(--border)",
    width: '100%',
    maxHeight: '35vh',
    overflowY: 'scroll',
  },

  wrapperCursos: {
    display: 'flex',
    flexDirection: 'column',
    width: "100%"
  },

  emojiBox: {
    position: "absolute",
    bottom: 63,
    width: 40,
    borderTop: "1px solid var(--border)",
  },

  estoqueBox: {
    position: "absolute",
    bottom: '63px',
    width: '800px',
    borderTop: "1px solid var(--border)",
    zIndex: 1000
  },

  circleLoading: {
    color: green[500],
    opacity: "70%",
    position: "absolute",
    top: "20%",
    left: "50%",
    marginLeft: -12,
  },

  audioLoading: {
    color: green[500],
    opacity: "70%",
  },

  recorderWrapper: {
    display: "flex",
    alignItems: "center",
    alignContent: "middle",
  },

  cancelAudioIcon: {
    color: "red",
  },

  sendAudioIcon: {
    color: "green",
  },

  replyginMsgWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 8,
    paddingLeft: 73,
    paddingRight: 7,
  },

  replyginMsgContainer: {
    flex: 1,
    marginRight: 5,
    overflowY: "hidden",
    backgroundColor: "var(--surface-3)",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  replyginMsgBody: {
    padding: 10,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  replyginContactMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  replyginSelfMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },
  messageQuickAnswersWrapper: {
    bottom: '63px !important',
    width: '800px !important',
    borderTop: "1px solid var(--border)",
    zIndex: 1000,
    color: "var(--text-primary)",
    margin: 0,
    position: "absolute",
    background: "var(--surface-1)",
    padding: "2px",
    border: "1px solid var(--border)",
    left: 0,
    "& li": {
      listStyle: "none",
      "& a": {
        display: "block",
        padding: "8px",
        fontSize: "var(--msg-font-size)",
        textOverflow: "ellipsis",
        overflow: "hidden",
        maxHeight: "32px",
        "&:hover": {
          background: "var(--surface-3)",
          cursor: "pointer",
        },
      },
    },
  },
  wrapperInputCurso: {
    display: 'flex',
    flexDirection: 'column'
  },
  spanNomeCurso: {
    backgroundColor: 'var(--surface-2)',
    color: 'var(--text-secondary)',
    borderRadius: '14px',
    padding: '4px 6px',
    fontStyle: 'italic',
    boxShadow: 'inset 0 0 5px #e0e0e0',
    transition: 'background-color 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    width: '100%',
  },
  inputNomeCurso: {
    backgroundColor: '#f5f5f5',
    color: '#6b6b6b',
    border: 'none',
    opacity: 1,
    borderRadius: '14px',
    fontStyle: 'italic',
    transition: 'background-color 0.2s ease',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  },
  tablecellProduto: {
    maxWidth: '300px'
  },
  labelcheckbox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    position: 'relative',
  },
  input: {
    position: 'absolute',
    opacity: 0,
    width: 0,
    height: 0,
  },
  box: {
    width: 20,
    height: 20,
    border: '2px solid #ccc',
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',

    '$labelcheckbox:hover &': {
      borderColor: '#4CAF50',
    },
  },
  checked: {
    backgroundColor: '#4CAF50',
    borderColor: '#4CAF50',

    '$labelcheckbox:hover &': {
      backgroundColor: '#4CAF50',
      borderColor: '#4CAF50',
    },
  },
  checkIcon: {
    color: '#fff',
    transform: 'scale(0)',
    transition: 'transform 0.2s ease',
  },
  checkIconVisible: {
    transform: 'scale(1)',
  },
  btnAvancar: {
    backgroundColor: '#25D366',
    color: '#fff',
    border: 'none',
    padding: '3px 6px',
    borderRadius: 6,
    fontSize: 10,
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease',

    '&:hover': {
      backgroundColor: '#1ebe5d',
    },
  },
  modalImages: {
    width: '80%',
    margin: 'auto'
  },
  miniImg: {
    width: '50px',
    height: '50px'
  },
  wrapperMedias: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    overflowY: 'scroll',
    maxHeight: '30vh',
  },
  wrapper: {
    marginBottom: 8,
  },
  singleImage: {
    width: 50,
    height: 50,
    objectFit: 'cover',
    borderRadius: 6,
  },
  stack: {
    position: 'relative',
    width: 50,
    height: 50,
  },
  stackImage: {
    position: 'absolute',
    width: 50,
    height: 50,
    objectFit: 'cover',
    borderRadius: 6,
    border: '2px solid #fff',
    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
    transition: '0.2s',
  },
  badge: {
    position: 'absolute',
    bottom: -6,
    right: -6,
    background: '#25D366',
    color: '#fff',
    borderRadius: '50%',
    width: 22,
    height: 22,
    fontSize: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
  },
  imagesWrapper: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    minWidth: 60,
  },
  imgMessage: {
    width: '100px',
    margin: '12px'
  },
  spanNomeProd: {
    backgroundColor: '#f5f5f5',
    color: '#6b6b6b',
    borderRadius: '14px',
    padding: '4px 6px',
    fontStyle: 'italic',
    boxShadow: 'inset 0 0 5px #e0e0e0',
    transition: 'background-color 0.2s ease',

    display: 'flex',
    alignItems: 'center',
    gap: 8,
    width: '100%',
  },
  inputNomeProd: {
    backgroundColor: '#f5f5f5',
    color: '#6b6b6b',
    border: 'none',
    opacity: 1,
    borderRadius: '14px',
    fontStyle: 'italic',
    transition: 'background-color 0.2s ease',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  },
  wrapperAnexos: {
    display: 'flex',
    flexDirection: 'row'
  },
  imgWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px'
  },
  cancelIcon: {
    color: '#dd0000 !important',
    '&:hover': {
      color: '#ce0000 !important',
      transform: 'scale(1.05)'
    }
  }
}));

const RenderTableProdutos = ({
  classes,
  produtosFiltrados,
  totalProdutosEncontrados,
  checkeds,
  handleAvancar,
  checkedProduto,
  handleRowClick,
  estoqueOpen,
  totalProdutosCarregados,
  grupos,
  gruposSelecionados,
  onAplicarGrupos,
  exibirPrecoMinimo,
}) => {
  // O popup só existe enquanto o estoque está aberto. Sem essa guarda, o ramo
  // de busca por imagem ficava sempre montado e provocava renders intermediários
  // visíveis (tabela vazia → header → linhas) durante o carregamento inicial.
  if (!estoqueOpen) return null;
  if (process.env.REACT_APP_BUSCA_IMAGEM_PRODUTO === 'on') {
    return <div className={classes.estoqueBox}>
      <BarraProdutosFiltro
        total={totalProdutosEncontrados}
        totalCarregado={totalProdutosCarregados}
        max={MAX_PRODUTOS_BUSCA}
        grupos={grupos}
        gruposSelecionados={gruposSelecionados}
        onAplicarGrupos={onAplicarGrupos}
      />
      <TableContainer component={Paper} style={{ maxHeight: 500, overflowY: "auto" }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
              <TableCell></TableCell>
              <TableCell className={classes.tablecellProduto}><b>Produto</b></TableCell>
              <TableCell><b>Estoque</b></TableCell>
              {exibirPrecoMinimo && <TableCell><b>Preço mínimo</b></TableCell>}
              <TableCell><b>Preço venda</b></TableCell>
              <TableCell>
                <b>
                  <button className={classes.btnAvancar} onClick={handleAvancar}>Avançar</button>
                </b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {produtosFiltrados.map((item) => {
              const isBuscaImagem = Boolean(process.env.REACT_APP_BUSCA_IMAGEM_PRODUTO === 'on');
              const isChecked = checkeds.some(i => i.id === item.id);
              return (
                <TableRow
                  key={item.id}
                  style={{ cursor: "pointer", ...estiloLinhaProdutoPromocional(item) }}
                  onClick={isBuscaImagem ? () => checkedProduto(item) : undefined}
                >
                  <TableCell className={classes.labelcheckbox}>
                    {isBuscaImagem && (
                      <>
                        <input
                          type="checkbox"
                          className={classes.input}
                          checked={isChecked}
                          readOnly
                        />
                        <div className={`${classes.box} ${isChecked ? classes.checked : ''}`}>
                          <CheckIcon
                            className={`${classes.checkIcon} ${isChecked ? classes.checkIconVisible : ''
                              }`}
                          />
                        </div>
                      </>
                    )}
                  </TableCell>
                  <TableCell className={classes.tablecellProduto}>
                    {item.nome}
                    <TagProdutoPromocional item={item} />
                  </TableCell>
                  <TableCell>{item.estoque}</TableCell>
                  {exibirPrecoMinimo && (
                    <TableCell>
                      {new Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      }).format(item.precoCusto)}
                    </TableCell>
                  )}
                  <TableCell>
                    {new Intl.NumberFormat("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    }).format(item.precoVenda)}
                  </TableCell>
                </TableRow>
              );
            }
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  }
  return (
    <div className={classes.estoqueBox}>
      <BarraProdutosFiltro
        total={totalProdutosEncontrados}
        totalCarregado={totalProdutosCarregados}
        max={MAX_PRODUTOS_BUSCA}
        grupos={grupos}
        gruposSelecionados={gruposSelecionados}
        onAplicarGrupos={onAplicarGrupos}
      />
      <TableContainer component={Paper} style={{ maxHeight: 500, overflowY: "auto" }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
              <TableCell><b>Produto</b></TableCell>
              <TableCell><b>Estoque</b></TableCell>
              {exibirPrecoMinimo && <TableCell><b>Preço mínimo</b></TableCell>}
              <TableCell><b>Preço venda</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {produtosFiltrados.map((item) => (
              <TableRow
                key={item.id}
                onClick={() => handleRowClick(item)}
                style={estiloLinhaProdutoPromocional(item)}
                sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}
              >
                <TableCell>
                  {item.nome}
                  <TagProdutoPromocional item={item} />
                </TableCell>
                <TableCell>{item.estoque}</TableCell>
                {exibirPrecoMinimo && (
                  <TableCell>
                    {new Intl.NumberFormat("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    }).format(item.precoCusto)}
                  </TableCell>
                )}
                <TableCell>
                  {new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }).format(item.precoVenda)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

const MessageInput = ({ ticket, ticketStatus, urlBackend, isGroup, tabelaPrecoId, setEstoqueOutrasLojas, setModalEstoqueOutrasLojasOpen }) => {
  const classes = useStyles();
  const { ticketId } = useParams();

  const [medias, setMedias] = useState([]);
  const [anexos, setAnexos] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [prodNome, setProdNome] = useState("");
  const [estoqueOpen, setEstoqueOpen] = useState(false);
  const [produtos, setProdutos] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  // Ids dos grupos aplicados no filtro da busca de produtos. Deliberadamente NÃO é limpo ao abrir
  // e fechar a caixinha de produtos: incluir um produto fecha a caixinha (ver handleRowClick e
  // handleAvancar), e a tarefa pede que a seleção de grupo sobreviva à inclusão. Só zera quando o
  // usuário troca de conversa (effect abaixo) ou mexe no filtro.
  const [gruposSelecionados, setGruposSelecionados] = useState([]);
  const filtroProdutosTimeoutRef = useRef(null);
  // Token monotônico do carregamento de produtos: garante que respostas atrasadas
  // não sobrescrevam o estado quando a tabela de preço muda rapidamente ou quando
  // o popup é fechado durante uma request em voo.
  const produtosRequestTokenRef = useRef(0);
  const [cursos, setCursos] = useState([]);
  const [cursosFiltrados, setCursosFiltrados] = useState([]);
  const [selectedCursos, setSelectedCursos] = useState([]);
  const [cursoOpen, setCursoOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [recording, setRecording] = useState(false);
  const [quickAnswers, setQuickAnswer] = useState([]);
  const [typeBar, setTypeBar] = useState(false);
  const [template, setTemplate] = useState(null);
  // Qual Mensagem Rápida originou o envio. Anda colado no `template` de propósito: os dois são
  // "o que está armado agora", e digitar por cima desarma os dois. Só o Dashboard CRM do ERP lê
  // isso (#14848) — separar template disparado pelo atendente do disparo por etapa.
  const [quickAnswerId, setQuickAnswerId] = useState(null);
  // Parâmetros do modelo da Meta da mensagem rápida escolhida, já resolvidos pelo backend
  // com os dados do atendimento (ver helpers/VariaveisMensagemRapida no backend). Fica num
  // ref amarrado ao shortcut, e não em estado próprio, porque `template` é limpo em uma
  // dúzia de lugares — comparando o shortcut, todo setTemplate(null) já invalida isto de
  // graça, sem precisar lembrar de zerar em cada um deles.
  const parametrosModeloRef = useRef(null);

  /**
   * Parâmetros a enviar com o template. Só valem para o modelo que está armado agora: se
   * `template` mudou ou foi limpo, o que estava guardado não serve mais.
   *
   * <p>Sem isto o envio ia com o nome do template e sem valor nenhum nas variáveis — a
   * Meta recusa por contagem de parâmetro. O disparo do ERP já manda assim
   * (CrmFacade.getBodyParameters); aqui era o pedaço que faltava.
   */
  const bodyParametersDoTemplate = () => {
    const armado = parametrosModeloRef.current;
    if (!template || !armado || armado.shortcut !== template) {
      return undefined;
    }
    return armado.bodyParameters;
  };

  const [mentions, setMentions] = useState([]);
  const [mentionQuery, setMentionQuery] = useState(null);
  const [mentionOptions, setMentionOptions] = useState([]);
  const [mentionBarOpen, setMentionBarOpen] = useState(false);
  const [groupParticipants, setGroupParticipants] = useState(null);
  const mentionTokenStart = useRef(null);
  const inputRef = useRef();
  const inputProdNomeRef = useRef();
  // Guarda SÍNCRONA de gravação. O `recording` (state) só atualiza no próximo
  // render; este ref reflete "gravando" no mesmo tick, impedindo um 2º start()
  // antes do re-render (o Mp3Recorder é singleton e um start() sem stop() deixa
  // o AudioContext anterior órfão alimentando o novo encoder → áudio dobrado).
  const recordingRef = useRef(false);
  //const [anchorEl, setAnchorEl] = useState(null);
  const { setReplyingMessage, replyingMessage } = useContext(ReplyMessageContext);
  const { user } = useContext(AuthContext);
  const [internalNoteModalOpen, setInternalNoteModalOpen] = useState(false);
  const [itensLeadOpen, setItensLeadOpen] = useState(false);
  const [itensLeadDisponivel, setItensLeadDisponivel] = useState(false);
  // Confirmação de "enviar como documento" (vídeo acima do limite do WhatsApp). Quem
  // espera a resposta é o handleSendMessage, não o render — daí o resolver no ref.
  const [confirmacaoVideoGrande, setConfirmacaoVideoGrande] = useState(null);
  const resolverConfirmacaoVideo = useRef(null);
  const [signMessage, setSignMessage] = useState(true);
  const [checkeds, setCheckeds] = useState([]);
  const [produtosSelecionados, setProdutosSelecionados] = useState([]);
  const apiCustom = createApi(urlBackend);
  const [loadingMedias, setLoadingMedias] = useState(false);
  const [mediasSelecionadas, setMediasSelecionadas] = useState([]);
  const [mensagemEnviando, setMensagemEnviando] = useState(false);
  const [loadingProdutos, setLoadingProdutos] = useState(false);
  const ticketTabelaPrecoIdSalvo = ticket?.tabelaPrecoId ?? tabelaPrecoId ?? null;
  const {
    tabelas: tabelasPreco,
    tabelaSelecionada: tabelaPrecoSelecionada,
    setTabelaSelecionada: setTabelaPrecoSelecionada,
  } = usePrecoTabelas({ ticketId, ticketTabelaPrecoId: ticketTabelaPrecoIdSalvo });

  // Lista derivada da busca: recomputada apenas quando `produtos` ou `searchTerm`
  // mudam. Não existe estado paralelo a sincronizar — assim a tabela nunca
  // renderiza um par "produtos novos / filtrados velhos" entre setStates.
  // Ordena antes do corte em MAX_PRODUTOS_BUSCA — senão seria o corte a escolher
  // quais produtos aparecem. Cópia porque `sort` muta, e `produtos` é estado.
  const produtosBuscados = useMemo(() => {
    const termos = (searchTerm || "").toLowerCase().split(" ").filter(Boolean);
    const doGrupo = filtrarProdutosPorGrupos(produtos, gruposSelecionados);

    const encontrados = termos.length === 0
      ? doGrupo
      : doGrupo.filter((item) => {
        const nome = (item.nome ?? "").toString().toLowerCase();

        return termos.every(termo =>
          nome.includes(termo)
        );
      });

    return [...encontrados].sort(compararPorPrecoVenda);
  }, [produtos, searchTerm, gruposSelecionados]);

  // Opções do filtro derivadas da lista carregada — só grupos que têm produto nesta filial.
  const gruposProdutos = useMemo(() => montarOpcoesGrupos(produtos), [produtos]);

  const produtosFiltrados = useMemo(
    () => produtosBuscados.slice(0, MAX_PRODUTOS_BUSCA),
    [produtosBuscados]
  );

  const totalProdutosEncontrados = produtosBuscados.length;
  const nomeFilial = produtos.length > 0 ? (produtos[0].nomeFilial || '') : '';
  const exibirPrecoMinimo = produtos.length === 0 || produtos[0].exibirPrecoMinimo !== false;

  useEffect(() => {
    inputRef.current.focus();
  }, [replyingMessage]);

  // "Acessar a tela novamente" limpa o filtro de grupo. Aqui isso é a conversa: o componente
  // remonta ao navegar, e quando só o parâmetro da rota muda é este effect que zera.
  useEffect(() => {
    setGruposSelecionados([]);
  }, [ticketId]);

  // O carrinho só aparece em funil de venda ou de O.S., como a aba Itens do lead no ERP.
  const leadIcode = ticket?.lead_icode;
  const funilIcode = ticket?.funil_icode;
  useEffect(() => {
    setItensLeadDisponivel(false);
    if (isGroup || !ticketId || !leadIcode
      || process.env.REACT_APP_UNICV === "on" || process.env.REACT_APP_REMOVER_AGENDAMENTO === 'on') {
      return;
    }
    let ativo = true;
    api.get(`/lead-itens/${ticketId}/disponivel`)
      .then(({ data }) => ativo && setItensLeadDisponivel(Boolean(data?.disponivel)))
      .catch(() => {});
    return () => { ativo = false; };
  }, [ticketId, leadIcode, funilIcode, isGroup]);

  useEffect(() => {
    if (!isGroup || groupParticipants !== null || !ticketId) return;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get(`/tickets/${ticketId}/group-participants`);
        if (cancelled) return;
        setGroupParticipants(Array.isArray(data?.participants) ? data.participants : []);
      } catch (err) {
        if (cancelled) return;
        setGroupParticipants([]);
      }
    })();
    return () => { cancelled = true; };
  }, [isGroup, ticketId, groupParticipants]);

  useEffect(() => {
    if (!isGroup) {
      setMentionOptions([]);
      return;
    }

    if (mentionQuery == null) return;
    const pool = Array.isArray(groupParticipants) ? groupParticipants : [];
    const q = (mentionQuery || "").toLowerCase();
    const filtered = q
      ? pool.filter(p => (p.name || "").toLowerCase().includes(q) || (p.number || "").includes(q))
      : pool;
    setMentionOptions(filtered.slice(0, 8));
  }, [mentionQuery, groupParticipants, isGroup]);

  useEffect(() => {
    inputRef.current.focus();
    return () => {
      setInputMessage("");
      setTemplate(null);
      setQuickAnswerId(null);
      setShowEmoji(false);
      setEstoqueOpen(false);
      setMedias([]);
      setReplyingMessage(null);
      // Seleção da tabela é persistida por ticket e gerenciada pelo usePrecoTabelas;
      // não resetamos aqui para não apagar a escolha salva ao trocar de conversa.
    };
  }, [ticketId, setReplyingMessage]);

  // Troca de conversa com gravação em curso: encerra o gravador e limpa o estado.
  // O MessageInput NÃO remonta ao trocar de ticket (usa useParams), então sem isto
  // o AudioContext/ScriptProcessorNode do singleton ficaria vivo e alimentaria a
  // próxima gravação (áudio picotado/dobrado), além de travar o recordingRef.
  const prevTicketIdRef = useRef(ticketId);
  useEffect(() => {
    if (prevTicketIdRef.current !== ticketId) {
      if (recordingRef.current) {
        try { Mp3Recorder.stop(); } catch (e) { /* nada gravando */ }
        recordingRef.current = false;
        setRecording(false);
      }
      prevTicketIdRef.current = ticketId;
    }
  }, [ticketId]);

  // Desmontagem com gravação ativa: só encerra o gravador (sem setState) para não
  // vazar o AudioContext do singleton.
  useEffect(() => {
    return () => {
      if (recordingRef.current) {
        try { Mp3Recorder.stop(); } catch (e) { /* ignore */ }
        recordingRef.current = false;
      }
    };
  }, []);

  const handleChangeInput = (e) => {
    const value = e.target.value;
    setInputMessage(value);
    setTemplate(null);
    setQuickAnswerId(null);
    handleLoadQuickAnswer(e.target.value);
    if (estoqueOpen) {
      filtrarProdutoPorNome(e.target.value);
    } else if (cursoOpen) {
      filtrarCursoPorNome(value)
    }
    detectMentionToken(value, e.target.selectionStart ?? value.length);
  };

  const detectMentionToken = (value, caretPos) => {
    // Menções só fazem sentido em grupos.
    if (!isGroup) {
      if (mentionBarOpen) setMentionBarOpen(false);
      return;
    }
    const upToCaret = value.slice(0, caretPos);
    const atIndex = upToCaret.lastIndexOf("@");
    if (atIndex < 0) {
      setMentionBarOpen(false);
      setMentionQuery(null);
      mentionTokenStart.current = null;
      return;
    }
    const charBefore = atIndex === 0 ? " " : upToCaret[atIndex - 1];
    if (!/\s/.test(charBefore) && atIndex !== 0) {
      setMentionBarOpen(false);
      setMentionQuery(null);
      mentionTokenStart.current = null;
      return;
    }
    const token = upToCaret.slice(atIndex + 1);
    if (/\s/.test(token)) {
      setMentionBarOpen(false);
      setMentionQuery(null);
      mentionTokenStart.current = null;
      return;
    }
    mentionTokenStart.current = atIndex;
    setMentionQuery(token);
    setMentionBarOpen(true);
  };

  const handleSelectMention = (contact) => {
    if (!isGroup) return;
    const pool = Array.isArray(groupParticipants) ? groupParticipants : [];
    const isParticipant = pool.some(p =>
      (contact.jid && p.jid === contact.jid) ||
      (contact.id != null && p.id === contact.id) ||
      (contact.number && String(p.number) === String(contact.number))
    );
    if (!isParticipant) {
      setMentionBarOpen(false);
      return;
    }
    const start = mentionTokenStart.current;
    if (start == null) {
      setMentionBarOpen(false);
      return;
    }
    const before = inputMessage.slice(0, start);
    const afterTokenIdx = start + 1 + (mentionQuery ? mentionQuery.length : 0);
    const after = inputMessage.slice(afterTokenIdx);
    const nome = (contact.name || contact.nome || contact.number || "").trim();
    const replacement = `@${nome} `;
    const newValue = `${before}${replacement}${after}`;
    setInputMessage(newValue);
    setMentions(prev => {
      const key = contact.jid ? `jid:${contact.jid}` : (contact.id != null ? `id:${contact.id}` : `num:${contact.number}`);
      const already = prev.some(m =>
        (m.jid && `jid:${m.jid}` === key) ||
        (m.id != null && `id:${m.id}` === key) ||
        (m.number && `num:${m.number}` === key)
      );
      if (already) return prev;
      return [...prev, { id: contact.id ?? null, nome, number: contact.number || null, jid: contact.jid || null }];
    });
    setMentionBarOpen(false);
    setMentionQuery(null);
    mentionTokenStart.current = null;
    setTimeout(() => {
      try {
        const el = inputRef.current;
        if (el && typeof el.setSelectionRange === "function") {
          const pos = (before + replacement).length;
          el.focus();
          el.setSelectionRange(pos, pos);
        }
      } catch (_) { }
    }, 0);
  };

  const handleQuickAnswersClick = (value) => {
    if (value.tipo === "TEXTO") {
      setInputMessage(value.message);
    } else {
      setInputMessage(`${value.tipo}ℵ1CʘD≡ℵ${value.anexo}ℵ1CʘD≡ℵ${value.message}`);
    }
    setTemplate(null);
    setQuickAnswerId(value.id);
    if (value.modelo) {
      setTemplate(value.shortcut);
      parametrosModeloRef.current = value.bodyParameters
        ? { shortcut: value.shortcut, bodyParameters: value.bodyParameters }
        : null;
    }
    setTypeBar(false);
  };

  const handleRowClick = useCallback(async (value) => {
    if (!value) return
    cancelarFiltroProdutosPendente();
    setTemplate(null);
    setQuickAnswerId(null);
    if (process.env.REACT_APP_UNICV === "on") {
      setSelectedCursos(prev => {
        const jaSelecionado = prev.some(curso => curso.id === value.id);
        return jaSelecionado ? prev.filter(curso => curso.id !== value.id) : [...prev, value];
      });
    } else if (process.env.REACT_APP_BUSCA_IMAGEM_PRODUTO === "on") {
      if (value.possuiAnexo || value.anexoId) {
        try {
          const { data } = await api.get(`/estoque/${ticketId}/${value.id}`);
          setMedias(prev => [...prev, data.imagemBase64]);
          setProdutosSelecionados(prev => [...prev, data]);
        } catch (error) {
          console.log(error);
        }
      } else {
        setProdutosSelecionados(prev => [...prev, value]);
      }
    }
    else {
      setInputMessage(value.nome);
      setEstoqueOpen(false);
    }
  }, [ticketId]);

  const handleAddEmoji = (e) => {
    let emoji = e.native;
    setInputMessage((prevState) => prevState + emoji);
    setTemplate(null);
    setQuickAnswerId(null);
  };

  const handleChangeMedias = (e) => {
    if (!e.target.files) {
      return;
    }

    const selectedMedias = Array.from(e.target.files);
    setAnexos(selectedMedias);
  };

  const handleInputPaste = (e) => {
    if (e.clipboardData.files[0]) {
      setAnexos([e.clipboardData.files[0]]);
    }
  };

  function base64ToBlob(base64, filename) {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  // Devolve `true` só quando TUDO da fila saiu. Na falha a fila para ali e sai do
  // campo só o que já foi entregue (anexo, imagem de produto e a legenda, que vai na
  // 1ª mídia): o atendente tenta de novo sem redigitar e sem duplicar. Ver #15215.
  const handleUploadMedia = async (activeMentions) => {
    setLoading(true);
    let enviouTudo = true;
    const anexosEnviados = [];
    const imagensEnviadas = [];
    const produtosEnviados = [];
    let textoEnviado = false;

    try {
      const queue = [];
      const texto = inputMessage?.trim();
      const hasTexto = !!texto;
      const hasAnexos = anexos && anexos.length > 0;

      const mentionsPayload = Array.isArray(activeMentions) ? activeMentions : [];

      let textoJaUsado = false;

      // =========================
      // 1. MÍDIAS
      // =========================
      if (hasAnexos) {
        anexos.forEach(media => {
          queue.push({
            type: "media",
            media,
          });
        });
      }

      // =========================
      // 2. PRODUTOS
      // =========================
      Object.keys(mediasSelecionadas).forEach(prodId => {
        const produto = mediasSelecionadas[prodId];

        if (produto.imagens && produto.imagens.length > 0) {
          produto.imagens.forEach(imgObj => {
            queue.push({
              type: "produtoImagem",
              nome: produto.nome,
              imagem: imgObj.imagem,
              imgObj,
            });
          });
        } else {
          queue.push({
            type: "produtoSemImagem",
            nome: produto.nome,
            prodId,
          });
        }
      });

      // =========================
      // 3. TEXTO SEMPRE POR ÚLTIMO
      // =========================
      if (hasTexto) {
        queue.push({
          type: "texto",
          texto,
        });
      }

      // =========================
      // ENVIO
      // =========================
      for (let i = 0; i < queue.length; i++) {
        const item = queue[i];

        const formData = new FormData();
        formData.append("fromMe", true);

        if (replyingMessage) {
          formData.append("quotedMsg", JSON.stringify(replyingMessage));
        }

        let body = "";
        let hasMediaItem = false;
        let itemCarregaTexto = false;

        // =========================
        // MÍDIA
        // =========================
        if (item.type === "media") {
          const file = typeof item.media === "string"
            ? base64ToBlob(item.media, `media-${i}.png`)
            : item.media;

          formData.append("medias", file);
          hasMediaItem = true;

          if (avaliarAnexo(file) === "videoGrande") {
            formData.append("comoDocumento", "true");
          }

          // texto só na primeira mídia
          if (hasTexto && !textoJaUsado) {
            body = signMessage
              ? `*${user?.name}:*\n${texto}`
              : texto;

            textoJaUsado = true;
            itemCarregaTexto = true;
          } else {
            body = signMessage
              ? `*${user?.name}:*\n`
              : ' ';
          }
        }

        // =========================
        // PRODUTO COM IMAGEM
        // =========================
        if (item.type === "produtoImagem") {
          const file = base64ToBlob(
            item.imagem.imagemBase64,
            `image-${i}.png`
          );

          formData.append("medias", file);
          hasMediaItem = true;
          body = `*${user?.name}:*\n*${item.nome}*`;
        }

        // =========================
        // PRODUTO SEM IMAGEM
        // =========================
        if (item.type === "produtoSemImagem") {
          // NUNCA usa o texto digitado
          body = `*${user?.name}:*\n*${item.nome}*`;
        }

        // =========================
        // TEXTO FINAL (SE NÃO FOI USADO)
        // =========================
        if (item.type === "texto") {
          // só envia se NÃO foi usado na mídia
          if (!textoJaUsado) {
            body = signMessage
              ? `*${user?.name}:*\n${item.texto}`
              : item.texto;
            itemCarregaTexto = true;
          } else {
            continue; // evita duplicação
          }
        }

        if (!hasMediaItem && !body.trim()) continue;

        formData.append("body", body);

        if (itemCarregaTexto && mentionsPayload.length) {
          formData.append("mentions", JSON.stringify(mentionsPayload));
        }

        try {
          await apiCustom.post(`/messages/${ticketId}`, formData);
        } catch (err) {
          enviouTudo = false;
          toastError(err);
          break;
        }

        if (item.type === "media") anexosEnviados.push(item.media);
        if (item.type === "produtoImagem") imagensEnviadas.push(item.imgObj);
        if (item.type === "produtoSemImagem") produtosEnviados.push(item.prodId);
        if (itemCarregaTexto) textoEnviado = true;
      }

    } catch (err) {
      enviouTudo = false;
      toastError(err);
    }

    setLoading(false);
    if (enviouTudo) {
      setMedias([]);
      setMediasSelecionadas({});
      setReplyingMessage(null);
      setAnexos([]);
    } else {
      setAnexos(prev => prev.filter(anexo => !anexosEnviados.includes(anexo)));
      setMediasSelecionadas(prev => {
        const restantes = {};
        Object.keys(prev).forEach(prodId => {
          const produto = prev[prodId];
          if (produtosEnviados.includes(prodId)) return;

          const imagens = (produto.imagens || []).filter(img => !imagensEnviadas.includes(img));
          if (produto.imagens?.length > 0 && imagens.length === 0) return;

          restantes[prodId] = { ...produto, imagens };
        });
        return restantes;
      });
      if (textoEnviado) {
        setInputMessage("");
        setMentions([]);
      }
    }
    return enviouTudo;
  };

  const convertToJpg = (file, quality = 0.9) => {
    if (!file.type?.startsWith("image/")) {
      return file;
    }

    return new Promise((resolve, reject) => {
      if (file.type === "image/jpeg") {
        return resolve(file);
      }

      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = (event) => {
        const img = new Image();

        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;

          const ctx = canvas.getContext("2d");

          ctx.fillStyle = "#fff";
          ctx.fillRect(0, 0, canvas.width, canvas.height);

          ctx.drawImage(img, 0, 0);

          canvas.toBlob(
            (blob) => {
              if (!blob) return reject("Erro ao converter imagem");

              const newFile = new File(
                [blob],
                file.name.replace(/\.\w+$/, ".jpg"),
                {
                  type: "image/jpeg",
                }
              );

              resolve(newFile);
            },
            "image/jpeg",
            quality // compressão (0 a 1)
          );
        };

        img.onerror = reject;
      };

      reader.onerror = reject;
    });
  };

  const buildActiveMentions = () => {
    if (!isGroup) return [];
    if (!mentions || mentions.length === 0) return [];
    const text = inputMessage || "";
    const pool = Array.isArray(groupParticipants) ? groupParticipants : [];
    const isParticipant = (m) => pool.some(p =>
      (m.jid && p.jid === m.jid) ||
      (m.id != null && p.id === m.id) ||
      (m.number && String(p.number) === String(m.number))
    );
    return mentions.filter(m => m?.nome && text.includes(`@${m.nome}`) && isParticipant(m));
  };

  const pedirConfirmacaoDocumento = arquivo =>
    new Promise(resolve => {
      resolverConfirmacaoVideo.current = resolve;
      setConfirmacaoVideoGrande(arquivo);
    });

  const responderConfirmacaoVideo = enviarComoDocumento => {
    const resolver = resolverConfirmacaoVideo.current;
    resolverConfirmacaoVideo.current = null;
    setConfirmacaoVideoGrande(null);
    if (resolver) resolver(enviarComoDocumento);
  };

  const handleSendMessage = async () => {
    if (estoqueOpen || cursoOpen) return;

    const activeMentions = buildActiveMentions();
    const temCursoSelecionado = selectedCursos.length > 0;
    const temProdutoSelecionado = produtosSelecionados.length > 0;
    const temAnexos = anexos.length > 0;
    const mensagemVazia = inputMessage.trim() === "";

    const podeEnviar =
      temAnexos ||
      temCursoSelecionado ||
      temProdutoSelecionado ||
      !mensagemVazia;

    if (!podeEnviar) return;

    // Limites do WhatsApp conferidos ANTES de subir o arquivo: acima do teto não há o
    // que fazer com ele, e vídeo acima de 16 MB só chega ao contato como documento —
    // decisão que é do atendente, não nossa. Ver #15215 e helpers/limitesMidia.
    const acimaDoTeto = anexos.find(anexo => avaliarAnexo(anexo) === "acimaDoTeto");
    if (acimaDoTeto) {
      toast.error(
        i18n.t("messagesInput.midia.acimaDoTeto", {
          nome: acimaDoTeto.name,
          tamanho: formatarTamanho(acimaDoTeto.size),
          limite: formatarTamanho(LIMITE_DOCUMENTO),
        }),
        { toastId: "midia-acima-do-teto" }
      );
      return;
    }

    // Recusar um só cancela o envio inteiro: a legenda é uma, e mandar metade do que
    // o atendente montou é pior que não mandar nada. O campo fica intacto.
    for (const video of anexos.filter(anexo => avaliarAnexo(anexo) === "videoGrande")) {
      const confirmou = await pedirConfirmacaoDocumento(video);
      if (!confirmou) return;
    }

    setLoading(true);
    setMensagemEnviando(true);
    let enviouTudo = true;
    const anexosEnviados = [];

    try {
      if (temCursoSelecionado && process.env.REACT_APP_UNICV === "on") {
        await Promise.all(
          selectedCursos.map(curso => {
            const message = {
              read: 1,
              fromMe: true,
              mediaUrl: "",
              body: `*${user?.name}:*\n*${curso.nome.trim()}*\nValor: ${new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
              }).format(curso.valor)}\nCarga Horária: ${curso.cargaHoraria}h\nDuração: ${curso.duracaoMeses} h`,
              quotedMsg: replyingMessage,
              template,
              quickAnswerId,
              bodyParameters: bodyParametersDoTemplate(),
            };

            return apiCustom.post(`/messages/${ticketId}`, message);
          })
        );

        if (!mensagemVazia) {
          await apiCustom.post(`/messages/${ticketId}`, {
            read: 1,
            fromMe: true,
            mediaUrl: "",
            body: `*${user?.name}:*\n${inputMessage.trim()}`,
            quotedMsg: replyingMessage,
            template,
            quickAnswerId,
            bodyParameters: bodyParametersDoTemplate(),
            ...(activeMentions.length ? { mentions: activeMentions } : {}),
          });
        }

      } else if (temProdutoSelecionado || process.env.REACT_APP_BUSCA_IMAGEM_PRODUTO === "on") {
        enviouTudo = await handleUploadMedia(activeMentions);
      } else if (anexos.length > 0) {
        // `for...of` com await, e não `.map(async ...)`: o map devolvia promessas que
        // ninguém aguardava, então o envio seguia solto — o finally já tinha limpado o
        // campo e a falha virava unhandled rejection, sem passar pelo catch abaixo. Era
        // o #15215: vídeo grande sumia do campo sem loader, sem confirmação e sem erro.
        for (const anexo of anexos) {

          const formData = new FormData();
          formData.append("fromMe", true);

          if (replyingMessage) {
            formData.append("quotedMsg", JSON.stringify(replyingMessage));
          }

          if (activeMentions.length) {
            formData.append("mentions", JSON.stringify(activeMentions));
          }

          let body = signMessage
            ? `*${user?.name}:*\n${inputMessage.trim()}`
            : inputMessage.trim();

          const file = await convertToJpg(anexo);
          formData.append("medias", file);
          formData.append('body', body);
          if (avaliarAnexo(anexo) === "videoGrande") {
            formData.append("comoDocumento", "true");
          }
          await apiCustom.post(`/messages/${ticketId}`, formData);
          anexosEnviados.push(anexo);
        }
      } else {
        await apiCustom.post(`/messages/${ticketId}`, {
          read: 1,
          fromMe: true,
          mediaUrl: "",
          body: signMessage
            ? `*${user?.name}:*\n${inputMessage.trim()}`
            : inputMessage.trim(),
          quotedMsg: replyingMessage,
          template,
          quickAnswerId,
          bodyParameters: bodyParametersDoTemplate(),
          ...(activeMentions.length ? { mentions: activeMentions } : {}),
        });
      }
    } catch (err) {
      enviouTudo = false;
      toastError(err);
    } finally {
      setMensagemEnviando(false);
      setLoading(false);
      // O que o atendente montou (anexo, produtos, curso, legenda, citação,
      // template) só é descartado quando saiu de verdade. Falhou, fica no lugar
      // pra ele tentar de novo, menos os anexos que já foram entregues — a
      // legenda fica, porque ela vai em cada anexo. O resto é estado de UI e
      // sempre fecha.
      if (enviouTudo) {
        setAnexos([]);
        setProdutosSelecionados([]);
        setInputMessage("");
        setCheckeds([]);
        setReplyingMessage(null);
        setTemplate(null);
        setQuickAnswerId(null);
        setSelectedCursos([])
        setMentions([]);
      } else if (anexosEnviados.length) {
        setAnexos(prev => prev.filter(anexo => !anexosEnviados.includes(anexo)));
      }
      setShowEmoji(false);
      setEstoqueOpen(false);
      setMentionBarOpen(false);
      setMentionQuery(null);
      mentionTokenStart.current = null;
    }
  };

  useEffect(() => {
    const fetchMessages = async () => {
      setShowEmoji(false);
      setLoading(false);
      setReplyingMessage(null);
      setTemplate(null);
      setQuickAnswerId(null);
    }
    fetchMessages();
  }, [estoqueOpen]);

  useEffect(() => {
    return () => {
      if (filtroProdutosTimeoutRef.current) {
        clearTimeout(filtroProdutosTimeoutRef.current);
      }
    };
  }, []);

  // Busca debounced: atualiza apenas o termo. A lista filtrada é derivada via
  // useMemo a partir de `produtos` + `searchTerm`, então um único setState
  // recompõe toda a tabela em uma única render — sem janela "filtrados velhos".
  const filtrarProdutoPorNome = (value) => {
    if (filtroProdutosTimeoutRef.current) {
      clearTimeout(filtroProdutosTimeoutRef.current);
    }
    filtroProdutosTimeoutRef.current = setTimeout(() => {
      setSearchTerm(value);
    }, 200);
  };

  const filtrarCursoPorNome = (value) => {
    const termos = value.toLowerCase().split(" ");
    setCursosFiltrados(cursos.filter((item) =>
      termos.every(termo => item.nome.toLowerCase().includes(termo))
    ));
  };

  const handleStartRecording = async () => {
    // Bloqueia start() concorrente (ver recordingRef). Sem isto, um clique duplo
    // no mic — há um await antes do setRecording(true) — dispara dois start() e
    // orfana um ScriptProcessorNode que passa a alimentar o encoder atual.
    if (recordingRef.current) return;

    if (!microfoneDisponivel()) {
      toast.error(i18n.t("messagesInput.audio.contextoInseguro"), { toastId: "erro-microfone" });
      return;
    }

    recordingRef.current = true;
    setLoading(true);
    try {
      // Defensivo: encerra qualquer sessão anterior não parada (ex.: erro prévio)
      // antes de abrir uma nova. O start() da lib já pede o microfone e rejeita
      // se negado — não precisamos do getUserMedia extra (que vazava um stream).
      try { Mp3Recorder.stop(); } catch (e) { /* nada gravando */ }
      await Mp3Recorder.start();
      setRecording(true);
      setLoading(false);
    } catch (err) {
      recordingRef.current = false;
      liberarContextoAudio();
      console.error("Falha ao iniciar a gravação de áudio:", err);
      // toastId fixo: sem ele cada clique empilhava um toast novo, e a tela
      // ficava coberta de avisos iguais.
      toast.error(mensagemErroMicrofone(err), { toastId: "erro-microfone" });
      setLoading(false);
    }
  };

  const handleLoadQuickAnswer = async (value) => {
    if (value && value.indexOf("/") === 0) {
      try {
        const { data } = await api.get("/quickAnswersFilial/", {
          params: { userId: user.id, ticketId: ticketId, searchParam: inputMessage.substring(1) },
        });
        setQuickAnswer(data.quickAnswers);
        if (data.quickAnswers.length > 0) {
          setTypeBar(true);
        } else {
          setTypeBar(false);
        }
      } catch (err) {
        setTypeBar(false);
      }
    } else {
      setTypeBar(false);
    }
  };

  const handleUploadAudio = async () => {
    recordingRef.current = false;
    setLoading(true);
    try {
      const [, blob] = await Mp3Recorder.stop().getMp3();
      // Gravação curta demais pra virar áudio: avisa, senão o clique no ✓
      // parecia ter enviado e a mensagem simplesmente não aparecia.
      if (blob.size < 10000) {
        toast.info(i18n.t("messagesInput.audio.semGravacao"), { toastId: "audio-sem-gravacao" });
        setLoading(false);
        setRecording(false);
        return;
      }

      const formData = new FormData();
      const filename = `${new Date().getTime()}.mp3`;
      formData.append("medias", blob, filename);
      formData.append("body", filename);
      formData.append("fromMe", true);
      if (replyingMessage) {
        formData.append("quotedMsg", JSON.stringify(replyingMessage));
      }
      await apiCustom.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      // "No buffer to send" é a lib dizendo que não havia áudio nenhum — não é
      // falha de envio, e o toast genérico não dizia isso a ninguém.
      if (err?.message === "No buffer to send") {
        toast.info(i18n.t("messagesInput.audio.semGravacao"), { toastId: "audio-sem-gravacao" });
      } else {
        toastError(err);
      }
    }

    setRecording(false);
    setLoading(false);
    setReplyingMessage(null);
  };

  // Cancelar é intencional: descartar gravação vazia rejeita com "No buffer to
  // send" na lib, e avisar disso só assustava quem clicou no X (ou deu ESC).
  const handleCancelAudio = async () => {
    recordingRef.current = false;
    try {
      await Mp3Recorder.stop().getMp3();
    } catch (e) {
      liberarContextoAudio();
    }
    setRecording(false);
  };

  // ESC em camadas: o ESC fecha a conversa (ver hooks/useEscFecharConversa), mas
  // só depois que não sobra nada aberto aqui embaixo. Da camada mais "de cima"
  // pra mais "de baixo" — devolver true "gasta" o ESC e a conversa não fecha.
  // Gravação vem primeiro de propósito: sair da conversa com o Mp3Recorder
  // (singleton) rodando é o pior caso.
  useEffect(() => registrarConsumidorEsc(() => {
    if (recordingRef.current) {
      handleCancelAudio();
      return true;
    }
    if (mentionBarOpen) {
      setMentionBarOpen(false);
      return true;
    }
    if (typeBar) {
      setTypeBar(false);
      return true;
    }
    if (showEmoji) {
      setShowEmoji(false);
      return true;
    }
    if (estoqueOpen) {
      setEstoqueOpen(false);
      return true;
    }
    if (cursoOpen) {
      setCursoOpen(false);
      return true;
    }
    // Pré-visualização de anexos/produtos: descarta como o botão de cancelar.
    if (anexos.length > 0 || Object.keys(mediasSelecionadas).length > 0) {
      setAnexos([]);
      setMediasSelecionadas({});
      return true;
    }
    if (replyingMessage) {
      setReplyingMessage(null);
      return true;
    }
    return false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [
    mentionBarOpen,
    typeBar,
    showEmoji,
    estoqueOpen,
    cursoOpen,
    anexos.length,
    mediasSelecionadas,
    replyingMessage,
  ]);

  const handleCursosOpen = async () => {
    if (!cursoOpen) {
      try {
        const { data } = await api.get(`/cursos/${ticketId}`);
        setCursos(data);
        setCursosFiltrados(data);
      } catch (error) {
        console.error(error)
      }
    }
    setCursoOpen(prev => !prev);
  }

  // Única fonte de carregamento de produtos.
  //
  // Reage a qualquer mudança em (estoqueOpen, ticketId, tabelaPrecoSelecionada),
  // o que cobre simetricamente:
  //   1. Abertura do popup (estoqueOpen: false → true).
  //   2. Troca manual de tabela pelo dropdown (localOverride muda no hook →
  //      tabelaPrecoSelecionada muda).
  //   3. ERP definindo tabelaPrecoId via socket (ticket atualiza → erpDefinida
  //      passa a true no hook → tabelaPrecoSelecionada reflete o ERP).
  //
  // Race protection: a cada execução o token é incrementado; a response só pode
  // chamar setProdutos/setLoadingProdutos se seu token ainda for o mais recente.
  // Quando o effect re-roda (cleanup → body), o cancelled local e o token novo
  // descartam silenciosamente respostas em voo do ciclo anterior.
  useEffect(() => {
    if (!estoqueOpen || !ticketId) {
      // Garante que o spinner não fique preso quando o popup é fechado durante
      // um request em voo, ou ao trocar de conversa.
      setLoadingProdutos(false);
      return undefined;
    }

    const token = ++produtosRequestTokenRef.current;
    let cancelled = false;
    setLoadingProdutos(true);

    const url = tabelaPrecoSelecionada
      ? `/estoque/${ticketId}?tabelaId=${tabelaPrecoSelecionada}`
      : `/estoque/${ticketId}`;

    api
      .get(url)
      .then(({ data }) => {
        if (cancelled || token !== produtosRequestTokenRef.current) return;
        // Sempre reflete a resposta — inclusive [] — para que o estado nunca
        // fique preso na tabela anterior quando a nova vier vazia.
        setProdutos(Array.isArray(data) ? data : []);
      })
      .catch((err) => {
        if (cancelled || token !== produtosRequestTokenRef.current) return;
        console.log("ERRO: " + err);
      })
      .finally(() => {
        if (cancelled || token !== produtosRequestTokenRef.current) return;
        setLoadingProdutos(false);
      });

    return () => {
      cancelled = true;
    };
  }, [estoqueOpen, ticketId, tabelaPrecoSelecionada]);

  const handleEstoqueOpen = useCallback(() => {
    if (!estoqueOpen) {
      // Reseta o filtro local antes de abrir; o reload em si fica a cargo do
      // effect acima quando estoqueOpen flipar para true.
      setSearchTerm("");
      if (filtroProdutosTimeoutRef.current) {
        clearTimeout(filtroProdutosTimeoutRef.current);
        filtroProdutosTimeoutRef.current = null;
      }
    }
    setEstoqueOpen(prev => !prev);
  }, [estoqueOpen]);

  // Wrapper fino para o select: apenas atualiza a seleção no hook. O reload é
  // disparado pelo effect ao notar a mudança em tabelaPrecoSelecionada.
  const handleTrocarTabelaPreco = useCallback((novaTabelaId) => {
    return setTabelaPrecoSelecionada(novaTabelaId);
  }, [setTabelaPrecoSelecionada]);

  const buscaCursosCheckados = (id) => {
    if (selectedCursos.length > 0 && id >= 0)
      return selectedCursos.some(curso => curso.id == id);

    return false;
  }

  const [dragOver, setDragOver] = useState(false);

  const handleFiles = (files) => {
    if (!files || files.length === 0) return;

    const fileArray = Array.from(files);

    handleChangeMedias({
      target: { files: fileArray }
    });
  };

  useEffect(() => {
    const preventDefaults = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    ["dragenter", "dragover", "dragleave", "drop"].forEach(eventName => {
      window.addEventListener(eventName, preventDefaults);
    });

    return () => {
      ["dragenter", "dragover", "dragleave", "drop"].forEach(eventName => {
        window.removeEventListener(eventName, preventDefaults);
      });
    };
  }, []);

  useEffect(() => {
    const handlePaste = (e) => {
      const items = e.clipboardData?.items;
      if (!items) return;

      const files = [];

      for (let item of items) {
        if (item.kind === "file") {
          const file = item.getAsFile();
          if (file) files.push(file);
        }
      }

      handleFiles(files);
    };

    window.addEventListener("paste", handlePaste);
    return () => window.removeEventListener("paste", handlePaste);
  }, []);

  const handleDrop = (e) => {
    const files = e.dataTransfer.files;
    handleFiles(files);
    setDragOver(false);
  };

  const renderReplyingMessage = (message) => {
    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span
            className={clsx(classes.replyginContactMsgSideColor, {
              [classes.replyginSelfMsgSideColor]: !message.fromMe,
            })}
          ></span>
          <div className={classes.replyginMsgBody}>
            {!message.fromMe && (
              <span className={classes.messageContactName}>
                {message.contact?.name}
              </span>
            )}
            {message.body}
          </div>
        </div>
        <IconButton
          aria-label="showRecorder"
          component="span"
          disabled={loading || ticketStatus !== "open"}
          onClick={() => setReplyingMessage(null)}
        >
          <ClearIcon className={classes.sendMessageIcons} />
        </IconButton>
      </div>
    );
  };

  const RenderInputWithCursos = () => {
    return selectedCursos.length > 0 && !cursoOpen && process.env.REACT_APP_UNICV === "on" &&
      <Paper elevation={0} square className={classes.viewMediaInputWrapperCurso}>
        <div className={classes.wrapperCursos}>
          {Object.entries(selectedCursos).map(([cursoId, curso]) => {
            return (
              <span key={cursoId} className={classes.spanNomeCurso}>
                <InputBase
                  className={classes.inputNomeCurso}
                  defaultValue={curso.nome}
                  onBlur={(e) => {
                    const novoNome = e.target.value;
                    if (novoNome === curso.nome) return;
                    setSelectedCursos(prev =>
                      prev.map(item =>
                        item.id === curso.id
                          ? { ...item, nome: novoNome }
                          : item
                      )
                    );
                  }}
                />
                <IconButton
                  className={classes.cancelIcon}
                  onClick={() => {
                    setSelectedCursos(prev => {
                      const newState = [...prev];
                      return newState.filter(c => c.id !== curso.id);
                    });
                  }}>
                  <CancelIcon />
                </IconButton>
              </span>
            );
          })}
        </div>
      </Paper>
  }

  const cancelarFiltroProdutosPendente = () => {
    if (filtroProdutosTimeoutRef.current) {
      clearTimeout(filtroProdutosTimeoutRef.current);
      filtroProdutosTimeoutRef.current = null;
    }
  };

  const checkedProduto = useCallback((item) => {
    setCheckeds(prev => {
      const isChecked = prev.some(i => i.id === item.id);
      return isChecked ? prev.filter(i => i.id !== item.id) : [...prev, item];
    });
  }, []);

  const handleAvancar = useCallback(async () => {
    setModalOpen(true);
    setLoadingMedias(true);
    setProdutosSelecionados([]);

    try {
      await Promise.all(
        checkeds.map((prod) => handleRowClick(prod))
      );
    } catch (error) {
      console.log(error);
    }

    setLoadingMedias(false);
    setTemplate(null);
    setQuickAnswerId(null);
    setEstoqueOpen(false);
  }, [checkeds, handleRowClick]);

  const ButtonCursos = () => {
    if (process.env.REACT_APP_UNICV === "on") {
      return <IconButton
        aria-label="cursos"
        component="span"
        disabled={loading || recording || ticketStatus !== "open"}
        onClick={handleCursosOpen}
      >
        <InventoryIcon className={classes.sendMessageIcons} />
      </IconButton>
    }
    return <></>
  }

  const RenderTableCursos = () => {
    if (cursoOpen && cursos && cursos.length > 0 && process.env.REACT_APP_UNICV === "on") {
      return <div className={classes.estoqueBox}>
        <TableContainer component={Paper} style={{ maxHeight: 500, overflowY: "auto" }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
                <TableCell></TableCell>
                <TableCell><b>Nome</b></TableCell>
                <TableCell><b>Carga Horária</b></TableCell>
                <TableCell><b>Duração</b></TableCell>
                <TableCell><b>Valor</b></TableCell>
                <TableCell>
                  <b>
                    <button className={classes.btnAvancar} onClick={handleCursosOpen}>Ok</button>
                  </b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cursosFiltrados.map((item) => {
                return (
                  <TableRow
                    key={item.id}
                    onClick={() => handleRowClick(item)}
                    sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}
                  >
                    <TableCell>
                      <input
                        type="checkbox"
                        className={classes.input}
                        checked={buscaCursosCheckados(item.id)}
                        readOnly
                      />
                      <div className={`${classes.box} ${buscaCursosCheckados(item.id) ? classes.checked : ''}`}>
                        <CheckIcon
                          className={`${classes.checkIcon} ${buscaCursosCheckados(item.id) ? classes.checkIconVisible : ''
                            }`}
                        />
                      </div>
                    </TableCell>
                    <TableCell>{item.nome}</TableCell>
                    <TableCell>{item.cargaHoraria}</TableCell>
                    <TableCell>{item.duracaoMeses}</TableCell>
                    <TableCell>
                      {new Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      }).format(item.valor)}
                    </TableCell>
                    <TableCell />
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    }
    return <></>
  }

  const RenderTypebar = () => {
    if (!typeBar) return <></>

    return <ul className={classes.messageQuickAnswersWrapper}>
      {quickAnswers.map((value, index) => {
        return (
          <li
            className={classes.messageQuickAnswersWrapperItem}
            key={index}
          >
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a onClick={() => handleQuickAnswersClick(value)}>
              {/* DOC usa o ícone de documento e VIDEO o de play: o modelo da Meta aceita
                  cabeçalho de imagem, vídeo ou documento, e sem isso a linha vinha sem ícone */}
              {value.tipo == 'TEXTO' || value.tipo == 'DOC' ? (
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                  <path d="M240-400h320v-80H240v80Zm0-120h480v-80H240v80Zm0-120h480v-80H240v80ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z" />
                </svg>
              ) : value.tipo == 'IMG' ? (
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                  <path d="M240-400h480L570-600 450-440l-90-120-120 160ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z" />
                </svg>
              ) : value.tipo == 'AUDIO' || value.tipo == 'VIDEO' ? (
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
                  <path d="m400-400 240-160-240-160v320ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z" />
                </svg>
              ) : ('')}{` ${value.shortcut} - ${value.message}`}
            </a>
          </li>
        );
      })}
    </ul>
  }

  const handleBuscaEstoqueOutraLoja = useCallback(async ({ item }) => {
    try {
      const { data } = await api.get(`/outras-lojas/${item.idFilial}/${item.id}`);
      setEstoqueOutrasLojas(data.items);
      setModalEstoqueOutrasLojasOpen(true);
    } catch (error) {
      console.log({ error });
    }
  }, [setEstoqueOutrasLojas, setModalEstoqueOutrasLojasOpen]);

  const RenderTableProdutosRoma = () => {
    // Fechada não desenha nada: a caixa vazia (absoluta, com borda) virava uma linha em cima da barra.
    if (!estoqueOpen) return <></>

    const PriceTableDropdown = () => {
      return <PriceTableSelector
        nomeFilial={nomeFilial}
        tabelas={tabelasPreco}
        selectedId={tabelaPrecoSelecionada}
        onChange={handleTrocarTabelaPreco}
        disabled={ticket?.tabelaPrecoId}
      />
    };

    if (process.env.REACT_APP_BUSCA_IMAGEM_PRODUTO === 'on') {
      return <div className={classes.estoqueBox}>
        {estoqueOpen && PriceTableDropdown()}
        {estoqueOpen && (
          <BarraProdutosFiltro
            total={totalProdutosEncontrados}
            totalCarregado={produtos.length}
            max={MAX_PRODUTOS_BUSCA}
            grupos={gruposProdutos}
            gruposSelecionados={gruposSelecionados}
            onAplicarGrupos={setGruposSelecionados}
          />
        )}
        {(estoqueOpen && produtos && produtos.length > 0 && process.env.REACT_APP_ROMA === "on" && nomeFilial.length > 1) && <TableContainer component={Paper} style={{ maxHeight: 500, overflowY: "auto" }}>
          {
            !tabelaPrecoSelecionada ? <p>Selecione uma tabela de preço</p> : <Table size="small" stickyHeader>
              <TableHead>
                <TableRow style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
                  <TableCell>
                    <b>
                      <button className={classes.btnAvancar} onClick={handleAvancar}><b>Avançar</b></button>
                    </b>
                  </TableCell>
                  <TableCell className={classes.tablecellProduto}><b>Produto</b></TableCell>
                  <TableCell><b>Estoque</b></TableCell>
                  <TableCell><b>Preço venda</b></TableCell>
                  <TableCell><b>Outras lojas</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {produtosFiltrados.map((item) => {
                  if (!tabelaPrecoSelecionada) return <p>Selecione uma tabela de preço</p>
                  const isBuscaImagem = Boolean(process.env.REACT_APP_BUSCA_IMAGEM_PRODUTO === 'on');
                  const isChecked = checkeds.some(i => i.id === item.id);
                  return (
                    <TableRow
                      key={item.id}
                      style={{ cursor: "pointer", ...estiloLinhaProdutoPromocional(item) }}
                    >
                      <TableCell className={classes.labelcheckbox}
                        onClick={isBuscaImagem ? () => checkedProduto(item) : undefined}
                      >
                        {isBuscaImagem && (
                          <>
                            <input
                              type="checkbox"
                              className={classes.input}
                              checked={isChecked}
                              readOnly
                            />
                            <div className={`${classes.box} ${isChecked ? classes.checked : ''}`}>
                              <CheckIcon
                                className={`${classes.checkIcon} ${isChecked ? classes.checkIconVisible : ''
                                  }`}
                              />
                            </div>
                          </>
                        )}
                      </TableCell>
                      <TableCell
                        onClick={isBuscaImagem ? () => checkedProduto(item) : undefined}
                        sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}>
                        {item.nome}
                        <TagProdutoPromocional item={item} />
                      </TableCell>
                      <TableCell
                        onClick={isBuscaImagem ? () => checkedProduto(item) : undefined} sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}>
                        {item.estoque}</TableCell>
                      <TableCell
                        onClick={isBuscaImagem ? () => checkedProduto(item) : undefined} sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}>
                        {new Intl.NumberFormat("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        }).format(item.precoVenda)}
                      </TableCell>
                      <TableCell
                        onClick={() => handleBuscaEstoqueOutraLoja({ item })}
                        style={{ textAlign: 'center' }}
                        sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}>
                        <SearchOutlined />
                      </TableCell>
                    </TableRow>
                  );
                }
                )}
              </TableBody>
            </Table>
          }

        </TableContainer>
        }
      </div>
    }
    else {
      return <div className={classes.estoqueBox}>
        {estoqueOpen && PriceTableDropdown()}
        {estoqueOpen && (
          <BarraProdutosFiltro
            total={totalProdutosEncontrados}
            totalCarregado={produtos.length}
            max={MAX_PRODUTOS_BUSCA}
            grupos={gruposProdutos}
            gruposSelecionados={gruposSelecionados}
            onAplicarGrupos={setGruposSelecionados}
          />
        )}
        {(estoqueOpen && produtos && produtos.length > 0 && process.env.REACT_APP_ROMA === "on" && nomeFilial.length > 1) && <TableContainer component={Paper} style={{ maxHeight: 500, overflowY: "auto" }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
                <TableCell><b>Produto</b></TableCell>
                <TableCell><b>Estoque</b></TableCell>
                <TableCell><b>Preço venda</b></TableCell>
                <TableCell style={{ textAlign: 'center' }}><b>Outras lojas</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {produtosFiltrados.map((item) => (
                <TableRow key={item.id} style={estiloLinhaProdutoPromocional(item)}>
                  <TableCell
                    onClick={() => handleRowClick(item)}
                    sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}>
                    {item.nome}
                    <TagProdutoPromocional item={item} />
                  </TableCell>
                  <TableCell
                    onClick={() => handleRowClick(item)}
                    sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}>
                    {item.estoque}</TableCell>
                  <TableCell
                    onClick={() => handleRowClick(item)}
                    sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}>
                    {new Intl.NumberFormat("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    }).format(item.precoVenda)}
                  </TableCell>
                  <TableCell
                    onClick={() => handleBuscaEstoqueOutraLoja({ item })}
                    style={{ textAlign: 'center' }}
                    sx={{ cursor: "pointer", "&:hover": { backgroundColor: "#f5f5f5" } }}>
                    <SearchOutlined />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        }
      </div>
    }

    return <></>
  }

  const ButtonProdutos = () => {
    // Grupo não tem lead/filial: a busca de estoque depende de ticket.filial_icode
    // (ver TicketController.estoque), então o botão não aparece em ticket de grupo.
    if (!isGroup && process.env.REACT_APP_UNICV !== "on" && process.env.REACT_APP_REMOVER_AGENDAMENTO !== 'on') {
      return <>
        {loadingProdutos && <CircularProgress className={classes.circleLoading} />}
        <IconButton
          aria-label="estoque"
          component="span"
          disabled={loading || recording || ticketStatus !== "open" || mensagemEnviando || loadingProdutos}
          onClick={handleEstoqueOpen}
        >
          <InventoryIcon className={classes.sendMessageIcons} />
        </IconButton>

      </>
    }
    return <></>
  }

  // Carrinho: os itens (peças e serviços) do lead no ERP, os mesmos da aba Itens do lead.
  const ButtonItensLead = () => {
    if (!itensLeadDisponivel) {
      return <></>
    }
    return (
      <IconButton
        aria-label="itens do lead"
        title="Itens do lead (orçamento)"
        component="span"
        disabled={loading || recording || ticketStatus !== "open" || mensagemEnviando}
        onClick={() => setItensLeadOpen(true)}
      >
        <ShoppingCartIcon className={classes.sendMessageIcons} />
      </IconButton>
    )
  }


  // if (!Boolean(process.env.REACT_APP_BUSCA_IMAGEM_PRODUTO === 'on') && mediasSelecionadas.length < 0)
  //   return (
  //     <Paper elevation={0} square className={classes.viewMediaInputWrapper}>
  //       {loading ? (
  //         <div>
  //           <CircularProgress className={classes.circleLoading} />
  //         </div>
  //       ) : (
  //         <>
  //           <div className={classes.messageInputWrapper}>
  //             {
  //               prodNome.length > 0 &&
  //               <span className={classes.spanNomeProd}>
  //                 <input
  //                   className={classes.inputNomeProd}
  //                   defaultValue={prodNome}
  //                   ref={inputProdNomeRef}
  //                   onBlur={(e) => {
  //                     setProdNome(e.target.value);
  //                   }}
  //                 />
  //                 <IconButton
  //                   aria-label="cancel-upload"
  //                   component="span"
  //                   onClick={(e) => {
  //                     setProdNome("");
  //                   }}
  //                 >
  //                   <CancelIcon className={classes.sendMessageIcons} />
  //                 </IconButton>
  //               </span>
  //             }
  //             <InputBase
  //               name="messageInput"
  //               inputRef={(input) => {
  //                 if (input) inputRef.current = input;
  //                 input && input.focus();
  //               }}
  //               className={classes.messageInput}
  //               placeholder={
  //                 ticketStatus === "open"
  //                   ? i18n.t("messagesInput.placeholderOpen")
  //                   : i18n.t("messagesInput.placeholderClosed")
  //               }
  //               multiline
  //               maxRows={5}
  //               value={inputMessage}
  //               onChange={handleChangeInput}
  //               disabled={recording || loading || ticketStatus !== "open"}
  //               onPaste={(e) => ticketStatus === "open" && handleInputPaste(e)}
  //               onKeyPress={(e) => {
  //                 if (loading || e.shiftKey) return;
  //                 if (e.key === "Enter") handleSendMessage();
  //               }}
  //             />
  //             {typeBar ? (
  //               <ul className={classes.messageQuickAnswersWrapper}>
  //                 {quickAnswers.map((value, index) => {
  //                   return (
  //                     <li
  //                       className={classes.messageQuickAnswersWrapperItem}
  //                       key={index}
  //                     >
  //                       {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
  //                       <a onClick={() => handleQuickAnswersClick(value)}>
  //                         {value.tipo == 'TEXTO' ? (
  //                           <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
  //                             <path d="M240-400h320v-80H240v80Zm0-120h480v-80H240v80Zm0-120h480v-80H240v80ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z" />
  //                           </svg>
  //                         ) : value.tipo == 'IMG' ? (
  //                           <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
  //                             <path d="M240-400h480L570-600 450-440l-90-120-120 160ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z" />
  //                           </svg>
  //                         ) : value.tipo == 'AUDIO' ? (
  //                           <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368">
  //                             <path d="m400-400 240-160-240-160v320ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z" />
  //                           </svg>
  //                         ) : ('')}{` ${value.shortcut} - ${value.message}`}
  //                       </a>
  //                     </li>
  //                   );
  //                 })}
  //               </ul>
  //             ) : (
  //               <div></div>
  //             )}
  //           </div>
  //         </>
  //       )}
  //       <IconButton
  //         aria-label="send-message"
  //         component="span"
  //         onClick={handleSendMessage}
  //         disabled={loading}
  //       >
  //         <SendIcon className={classes.sendMessageIcons} />
  //       </IconButton>
  //     </Paper>
  //   );
  const contemMediasSelecionadas = Object.keys(mediasSelecionadas).length > 0;
  const contemAnexos = anexos.length > 0;

  // Vai nos DOIS ramos do return: com anexo na tela quem renderiza é o primeiro, e é
  // justamente aí que esta modal precisa aparecer.
  const modalVideoGrande = (
    <Dialog
      open={!!confirmacaoVideoGrande}
      onClose={() => responderConfirmacaoVideo(false)}
      aria-labelledby="confirma-video-grande"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id="confirma-video-grande">
        {i18n.t("messagesInput.midia.tituloVideoGrande")}
      </DialogTitle>
      <DialogContent dividers>
        <Typography>
          {i18n.t("messagesInput.midia.videoGrande", {
            nome: confirmacaoVideoGrande?.name,
            tamanho: formatarTamanho(confirmacaoVideoGrande?.size),
            limite: formatarTamanho(LIMITE_VIDEO),
          })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <BotaoCancelar onClick={() => responderConfirmacaoVideo(false)}>
          {i18n.t("confirmationModal.buttons.cancel")}
        </BotaoCancelar>
        <BotaoConfirmar onClick={() => responderConfirmacaoVideo(true)}>
          {i18n.t("messagesInput.midia.enviarComoDocumento")}
        </BotaoConfirmar>
      </DialogActions>
    </Dialog>
  );

  if (contemMediasSelecionadas || contemAnexos) {
    return <Paper elevation={0} square className={classes.viewMediaInputWrapper}>
      {modalVideoGrande}
      {loadingMedias ? (
        <div>
          <CircularProgress className={classes.circleLoading} />
        </div>
      ) : mensagemEnviando ? <div >
        <CircularProgress className={classes.circleLoading} />
      </div> : <div className={classes.wrapperMedias}>
        {Object.keys(mediasSelecionadas).map(prodId => {
          const produto = mediasSelecionadas[prodId];
          const imagens = produto.imagens;
          return (
            <span key={prodId} className={classes.spanNomeProd}>
              <div className={classes.imagesWrapper}>
                {imagens.length === 0 ? (
                  <span style={{ fontSize: 10, color: '#999' }}>
                    Sem imagem
                  </span>
                ) : imagens.length === 1 ? (
                  <img
                    src={imagens[0].imagem.imagemBase64}
                    className={classes.singleImage}
                  />
                ) : (
                  imagens.slice(0, 2).reverse().map((imgObj, index) => (
                    <img
                      key={imgObj.imagem.anexoId}
                      src={imgObj.imagem.imagemBase64}
                      className={classes.stackImage}
                      style={{
                        transform: `translate(-${index * 6}px, ${index * 6}px)`
                      }}
                    />
                  ))
                )}
              </div>

              <InputBase
                className={classes.inputNomeProd}
                defaultValue={produto.nome}
                onBlur={(e) => {
                  const novoNome = e.target.value;

                  setMediasSelecionadas(prev => ({
                    ...prev,
                    [prodId]: {
                      ...prev[prodId],
                      nome: novoNome
                    }
                  }));
                }}
              />

              <IconButton onClick={() => {
                setMediasSelecionadas(prev => {
                  const newState = { ...prev };
                  delete newState[prodId];
                  return newState;
                });
              }}>
                <CancelIcon />
              </IconButton>
            </span>
          );
        })}
        <div className={classes.imgWrapper}>
          {anexos.length <= 5 && anexos.map((media, index) => {
            if (!media.type.startsWith("image/")) return <div>
              <IconButton onClick={() => {
                setAnexos(prev => prev.filter((_, i) => i !== index));
              }}>
                <CancelIcon />
              </IconButton>
              <span>{media.name}</span>
            </div>
            const url = URL.createObjectURL(media);
            return (
              <div className={classes.wrapperAnexos}>
                <IconButton onClick={() => {
                  setAnexos(prev => prev.filter((_, i) => i !== index));
                }}>
                  <CancelIcon />
                </IconButton>
                <img
                  key={index}
                  src={url}
                  className={classes.singleImage}
                  alt="preview"
                  style={{ width: 75, height: 75 }}
                />
              </div>
            );
          })
          }
          {
            anexos.length > 5 && <div>
              <IconButton onClick={() => {
                setAnexos([]);
              }}>
                <CancelIcon />
              </IconButton>
              <span>Mais que 5 anexos</span>
            </div>
          }
        </div>
        <div className={classes.messageInputWrapper}>
          {mentionBarOpen && mentionOptions.length > 0 && (
            <ClickAwayListener onClickAway={() => setMentionBarOpen(false)}>
              <ul style={{
                position: "absolute",
                bottom: "100%",
                left: 0,
                right: 0,
                margin: 0,
                padding: 4,
                background: "#fff",
                border: "1px solid #CCC",
                borderRadius: 6,
                listStyle: "none",
                maxHeight: 180,
                overflowY: "auto",
                zIndex: 1000,
              }}>
                {mentionOptions.map(c => (
                  <li
                    key={c.jid || (c.id != null ? `id:${c.id}` : `num:${c.number || ""}`)}
                    onMouseDown={(e) => { e.preventDefault(); handleSelectMention(c); }}
                    style={{ padding: "6px 8px", cursor: "pointer" }}
                  >
                    <strong>{c.name || c.number || "—"}</strong>
                    {c.number && c.name ? <span style={{ color: "#888", marginLeft: 8 }}>{c.number}</span> : null}
                  </li>
                ))}
              </ul>
            </ClickAwayListener>
          )}
          <InputBase
            name="messageInput"
            inputRef={(input) => {
              if (input) inputRef.current = input;
              input && input.focus();
            }}
            className={classes.messageInput}
            placeholder={
              ticketStatus === "open"
                ? i18n.t("messagesInput.placeholderOpen")
                : ticketStatus === "pending"
                  ? i18n.t("messagesInput.placeholderPending")
                  : i18n.t("messagesInput.placeholderClosed")
            }
            multiline
            maxRows={5}
            value={inputMessage}
            onChange={handleChangeInput}
            disabled={recording || loading || ticketStatus !== "open" || mensagemEnviando}
            onPaste={(e) => ticketStatus === "open" && handleInputPaste(e)}
            // Mesmo tratamento do input sem anexo: onKeyDown com preventDefault.
            // Com onKeyPress e sem preventDefault, o Enter enviava E o navegador
            // inseria a quebra de linha depois — o onChange gravava "\n" no
            // estado e sobrava um enter vazio no campo após o envio.
            onKeyDown={(e) => {
              if (loading || mensagemEnviando) return;
              if (e.key === "Enter" && e.shiftKey) return;

              if (e.key === "Enter") {
                e.preventDefault();
                handleSendMessage();
              }
            }}
          />
        </div>
      </div>}
      <IconButton
        aria-label="send-message"
        component="span"
        onClick={handleSendMessage}
        disabled={loading || mensagemEnviando}
      >
        <SendIcon className={classes.sendMessageIcons} />
      </IconButton>
    </Paper>
  } else {
    return (
      <div
        onDrop={handleDrop}
        onDragEnter={() => setDragOver(true)}
        onDragOver={() => setDragOver(true)}
        onDragLeave={() => setDragOver(false)}
      >
        <Paper square elevation={0} className={classes.mainWrapper}>
          {modalVideoGrande}
          <RenderInputWithCursos />

          {/* TYPE BAR */}
          <RenderTypebar />

          {replyingMessage && renderReplyingMessage(replyingMessage)}
          <div className={classes.newMessageBox}>
            <ButtonCursos />
            <RenderTableCursos />
            <ButtonProdutos />
            <ButtonItensLead />
            {process.env.REACT_APP_ROMA !== "on" && (
              <RenderTableProdutos
                classes={classes}
                produtosFiltrados={produtosFiltrados}
                totalProdutosEncontrados={totalProdutosEncontrados}
                checkeds={checkeds}
                handleAvancar={handleAvancar}
                checkedProduto={checkedProduto}
                handleRowClick={handleRowClick}
                estoqueOpen={estoqueOpen}
                totalProdutosCarregados={produtos.length}
                grupos={gruposProdutos}
                gruposSelecionados={gruposSelecionados}
                onAplicarGrupos={setGruposSelecionados}
                exibirPrecoMinimo={exibirPrecoMinimo}
              />
            )}
            {process.env.REACT_APP_ROMA === "on" && (
              <RenderTableProdutosRoma
                classes={classes}
                estoqueOpen={estoqueOpen}
                produtos={produtos}
                produtosFiltrados={produtosFiltrados}
                totalProdutosEncontrados={totalProdutosEncontrados}
                nomeFilial={nomeFilial}
                tabelasPreco={tabelasPreco}
                tabelaPrecoSelecionada={tabelaPrecoSelecionada}
                ticketTabelaPrecoIdSalvo={ticketTabelaPrecoIdSalvo}
                onTrocarTabelaPreco={handleTrocarTabelaPreco}
                checkeds={checkeds}
                onAvancar={handleAvancar}
                onCheckedProduto={checkedProduto}
                onRowClick={handleRowClick}
                onBuscaEstoqueOutraLoja={handleBuscaEstoqueOutraLoja}
                maxProdutosBusca={MAX_PRODUTOS_BUSCA}
                buscaImagemHabilitada={process.env.REACT_APP_BUSCA_IMAGEM_PRODUTO === 'on'}
                grupos={gruposProdutos}
                gruposSelecionados={gruposSelecionados}
                onAplicarGrupos={setGruposSelecionados}
              />
            )}
            {/* EMOJIS */}
            <IconButton
              aria-label="emojiPicker"
              disabled={loading || recording || ticketStatus !== "open" || mensagemEnviando}
              onClick={() => setShowEmoji(prev => !prev)}
            >
              <MoodIcon className={classes.sendMessageIcons} />
            </IconButton>

            {showEmoji && (
              <div className={classes.emojiBox}>
                <ClickAwayListener onClickAway={() => setShowEmoji(false)}>
                  <Picker
                    perLine={16}
                    showPreview={false}
                    showSkinTones={false}
                    onSelect={handleAddEmoji}
                  />
                </ClickAwayListener>
              </div>
            )}

            {/* UPLOAD */}
            <IconButton
              component="label"
              disabled={loading || recording || ticketStatus !== "open"}
            >
              <AttachFileIcon className={classes.sendMessageIcons} />
              <input
                hidden
                multiple
                type="file"
                onChange={(e) => {
                  handleChangeMedias(e);
                  e.target.value = null;
                }}
              />
            </IconButton>
            {/* COMENTÁRIO INTERNO */}
            <IconButton
              aria-label="comentarioInterno"
              title="Comentário Interno"
              onClick={() => setInternalNoteModalOpen(true)}
            >
              <CommentIcon className={classes.sendMessageIcons} />
            </IconButton>
            <InternalNoteModal
              modalOpen={internalNoteModalOpen}
              onClose={() => setInternalNoteModalOpen(false)}
              ticketId={ticketId}
              userId={user?.id}
            />
            {itensLeadDisponivel && (
              <ItensLeadModal
                modalOpen={itensLeadOpen}
                onClose={() => setItensLeadOpen(false)}
                ticketId={ticketId}
              />
            )}
            {/* INPUT */}
            <div className={classes.messageInputWrapper}>
              {mentionBarOpen && mentionOptions.length > 0 && (
                <ClickAwayListener onClickAway={() => setMentionBarOpen(false)}>
                  <ul style={{
                    position: "absolute",
                    bottom: "100%",
                    left: 0,
                    right: 0,
                    margin: 0,
                    padding: 4,
                    background: "#fff",
                    border: "1px solid #CCC",
                    borderRadius: 6,
                    listStyle: "none",
                    maxHeight: 180,
                    overflowY: "auto",
                    zIndex: 1000,
                  }}>
                    {mentionOptions.map(c => (
                      <li
                        key={c.id}
                        onMouseDown={(e) => { e.preventDefault(); handleSelectMention(c); }}
                        style={{ padding: "6px 8px", cursor: "pointer" }}
                      >
                        <strong>{c.name}</strong>
                        {c.number ? <span style={{ color: "#888", marginLeft: 8 }}>{c.number}</span> : null}
                      </li>
                    ))}
                  </ul>
                </ClickAwayListener>
              )}
              <InputBase
                inputRef={(input) => {
                  if (input) inputRef.current = input;
                  input && input.focus();
                }}
                className={classes.messageInput}
                placeholder={
                  ticketStatus === "open"
                    ? i18n.t("messagesInput.placeholderOpen")
                    : ticketStatus === "pending"
                      ? i18n.t("messagesInput.placeholderPending")
                      : i18n.t("messagesInput.placeholderClosed")
                }
                multiline
                maxRows={5}
                value={inputMessage}
                onChange={handleChangeInput}
                disabled={recording || loading || ticketStatus !== "open" || mensagemEnviando}
                onKeyDown={(e) => {
                  if (loading) return;
                  if (e.key === "Escape" && mentionBarOpen) {
                    setMentionBarOpen(false);
                    return;
                  }
                  if (e.key === "Enter" && e.shiftKey) return;

                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSendMessage();
                  }
                }}
              />
            </div>

            {/* BOTÃO ENVIO / AUDIO */}
            {inputMessage ? (
              <IconButton
                aria-label="sendMessage"
                onClick={handleSendMessage}
                disabled={loading || mensagemEnviando}
              >
                <SendIcon className={classes.sendMessageIcons} />
              </IconButton>
            ) : recording ? (
              <div className={classes.recorderWrapper}>
                <IconButton onClick={handleCancelAudio}>
                  <HighlightOffIcon className={classes.cancelAudioIcon} />
                </IconButton>

                {loading ? <CircularProgress /> : <RecordingTimer />}

                <IconButton onClick={handleUploadAudio}>
                  <CheckCircleOutlineIcon className={classes.sendAudioIcon} />
                </IconButton>
              </div>
            ) : (
              <IconButton
                aria-label="showRecorder"
                disabled={loading || ticketStatus !== "open" || mensagemEnviando}
                onClick={handleStartRecording}
              >
                <MicIcon className={classes.sendMessageIcons} />
              </IconButton>
            )}

          </div>

          {/* MODAL */}
          {
            !loadingMedias && modalOpen && (
              <Suspense fallback={<CircularProgress className={classes.circleLoading} />}>
                <MediasModal
                  handleClose={() => setModalOpen(false)}
                  modalOpen={modalOpen}
                  produtosSelecionados={produtosSelecionados}
                  setMediasSelecionadas={setMediasSelecionadas}
                />
              </Suspense>
            )
          }
        </Paper >
      </div>
    );
  }
}

export default MessageInput;